import { useState } from 'react';
import { ClickOutsideDetector, IconDown, IconSelected, IconUp } from '@ui/src';
import { Period } from '../../hoc/dashboard/types';
import { PeriodPickerTypes } from './types';

import cn from './dashboard.module.css';

const getPeriodName = (period?: Period) => {
  let periodName: string;

  switch (period) {
    case Period.MONTH:
      periodName = 'Month';
      break;
    case Period.QUARTER:
      periodName = 'Quarter';
      break;
    case Period.TODAY:
      periodName = 'Today';
      break;
    case Period.WEEK:
      periodName = 'Week';
      break;
    case Period.YESTERDAY:
      periodName = 'Yesterday';
      break;
    default:
      periodName = 'Select period';
      break;
  }

  return periodName;
};

const PeriodPicker = ({
  className,
  period,
  setPeriod, // getValues,
}: PeriodPickerTypes) => {
  const [periodMenuVisible, setPeriodMenuVisible] = useState(false);

  return (
    <ClickOutsideDetector setOptionsListVisible={setPeriodMenuVisible}>
      <div className={`${cn.dropdownWrapper} ${className || ''}`}>
        <button
          type="button"
          className={`${cn.dropdownButton} ${
            periodMenuVisible ? cn.dropdownButtonActive : ''
          }`}
          onClick={() => setPeriodMenuVisible(!periodMenuVisible)}
        >
          <div className={cn.dropdownButtonLeft}>
            <div className={cn.dropdownButtonValue}>
              {getPeriodName(period)}
            </div>
          </div>
          <div className={cn.dropdownButtonRight}>
            {periodMenuVisible ? <IconUp /> : <IconDown />}
          </div>
        </button>
        {periodMenuVisible && (
          <ul className={cn.dropdownMenu}>
            <li className={cn.dropdownMenuTitle}>Select period</li>
            <li>
              <button
                type="button"
                className={cn.dropdownMenuButton}
                onClick={() => {
                  setPeriod(Period.TODAY);
                  setPeriodMenuVisible(false);
                }}
              >
                <div className={cn.dropdownMenuButtonLeft}>
                  <div className={cn.dropdownMenuButtonValue}>Today</div>
                </div>

                {period === Period.TODAY && <IconSelected />}
              </button>
            </li>
            <li>
              <button
                type="button"
                className={cn.dropdownMenuButton}
                onClick={() => {
                  setPeriod(Period.YESTERDAY);
                  setPeriodMenuVisible(false);
                }}
              >
                <div className={cn.dropdownMenuButtonLeft}>
                  <div className={cn.dropdownMenuButtonValue}>Yesterday</div>
                </div>
                {period === Period.YESTERDAY && <IconSelected />}
              </button>
            </li>
            <li>
              <button
                type="button"
                className={cn.dropdownMenuButton}
                onClick={() => {
                  setPeriod(Period.WEEK);
                  setPeriodMenuVisible(false);
                }}
              >
                <div className={cn.dropdownMenuButtonLeft}>
                  <div className={cn.dropdownMenuButtonValue}>Week</div>
                </div>
                {period === Period.WEEK && <IconSelected />}
              </button>
            </li>
            <li>
              <button
                type="button"
                className={cn.dropdownMenuButton}
                onClick={() => {
                  setPeriod(Period.MONTH);
                  setPeriodMenuVisible(false);
                }}
              >
                <div className={cn.dropdownMenuButtonLeft}>
                  <div className={cn.dropdownMenuButtonValue}>Month</div>
                </div>
                {period === Period.MONTH && <IconSelected />}
              </button>
            </li>
            {/* <li>
              <button
                type="button"
                className={cn.dropdownMenuButton}
                onClick={() => {
                  setPeriod(Period.QUARTER);
                  setPeriodMenuVisible(false);
                }}
              >
                <div className={cn.dropdownMenuButtonLeft}>
                  <div className={cn.dropdownMenuButtonValue}>Quarter</div>
                </div>
                {period === Period.QUARTER && <IconSelected />}
              </button>
            </li> */}
          </ul>
        )}
      </div>
    </ClickOutsideDetector>
  );
};

export default PeriodPicker;
